/*
 * AppUpdateWall Messages
 *
 * This contains all the text for the AppUpdateWall component.
 */
import { defineMessages } from 'react-intl';

export const appUpdateWallScope = 'app.components.appUpdateWall';

export const appUpdateWallMessages = {
  title: {
    id: `${appUpdateWallScope}.title`,
    defaultMessage: 'Mise à jour requise',
    en: 'Update required',
    it: 'Aggiornamento necessario',
    es: 'Actualización necesaria',
    de: 'Update erforderlich',
    nl: 'Update vereist',
  },
  description: {
    id: `${appUpdateWallScope}.description`,
    defaultMessage:
      'Pour continuer à rechercher et réserver vos trajets, mettez à jour l’application. Cela ne prend qu’une minute.',
    en: 'To continue searching and booking trips, please update the app. It only takes a minute.',
    it: 'Per continuare a cercare e prenotare i tuoi viaggi, aggiorna l’app. Ci vuole solo un minuto.',
    es: 'Para seguir buscando y reservando viajes, actualiza la aplicación. Solo lleva un minuto.',
    de: 'Um weiterhin Reisen zu suchen und zu buchen, aktualisieren Sie bitte die App. Es dauert nur eine Minute.',
    nl: 'Werk de app bij om te blijven zoeken en boeken. Het duurt maar een minuut.',
  },
  update: {
    id: `${appUpdateWallScope}.update`,
    defaultMessage: 'Mettre à jour',
    en: 'Update now',
    it: 'Aggiorna ora',
    es: 'Actualizar ahora',
    de: 'Jetzt aktualisieren',
    nl: 'Nu bijwerken',
  },
};

export default defineMessages(appUpdateWallMessages);
